<a class="nav-link" href="#" (click)="selectOption($event, 'mais_recente')"
  [ngClass]="{ 'font-weight-bold text-primary': ordenacao === 'mais_recente' }">Mais Recentes</a>